import firebase from 'firebase'

const config = {
apiKey: "AIzaSyB8Ppi9MZ6KifJNpsTsrqtAHvDj7VYyiUE",
authDomain: "meal-prep-a8bac.firebaseapp.com",
databaseURL: "https://meal-prep-a8bac.firebaseio.com",
projectId: "meal-prep-a8bac",
storageBucket: "meal-prep-a8bac.appspot.com",
messagingSenderId: "936807473071"
};

firebase.initializeApp(config);